import React, { FunctionComponent } from 'react';
import Svg, { Circle, G } from 'react-native-svg';
import { StyleSheet, Text, View, StyleProp, TextStyle } from 'react-native';
import Theme from '../../theme';
import { scaleText } from '../../utils/scaling';

interface DataPoint {
  value: number;
  color: string;
  key: string;
}

interface IProps {
  radius: number;
  strokeWidth: number;
  data: DataPoint[];
  textStyle?: StyleProp<TextStyle>;
}

export const PieChart: FunctionComponent<IProps> = ({
                                                      radius,
                                                      strokeWidth,
                                                      data = [],
                                                      textStyle,
                                                    }) => {
  const circumference = 2 * Math.PI * radius;
  const halfCircle = radius + strokeWidth;

  const pieTotal = data.reduce((acc, dataPoint) => acc + dataPoint.value, 0)

  const offsets = data.map((point, index) => ({
    offset: circumference * (1 - sumTillIndex(index) / pieTotal),
    color: point.color
  }))

  function sumTillIndex(index) {
    const a = data.slice(index)
    return a.reduce((acc, dataPoint) => acc + dataPoint.value, 0)
  }

  return (
    <View style={{ width: radius * 2, height: radius * 2, transform: [{ rotate: '270deg' }] }}>
      <Svg
        height={radius * 2}
        width={radius * 2}
        viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
      >
        <G
          origin={`${halfCircle}, ${halfCircle}`}
          style={{ transform: [{ rotate: '90deg' }] }}
        >
          {
            offsets.map((offset, index) => (
              <Circle
                cx='50%'
                cy='50%'
                r={radius}
                key={index}
                fill='transparent'
                stroke={offset.color}
                strokeWidth={strokeWidth}
                strokeDashoffset={offset.offset}
                strokeDasharray={circumference}
              />
            ))
          }
        </G>
      </Svg>
      <View
        style={[
          StyleSheet.absoluteFillObject,
          { justifyContent: 'center' },
          { transform: [{ rotate: '-270deg' }] },
        ]}
      >
        <Text style={[style.totalText, textStyle]}>{pieTotal}</Text>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  totalText: {
    color: Theme.GREY_DARK,
    fontSize: scaleText(46),
    fontWeight: '700',
    textAlign: 'center',
  }
})
